import { KIOSK_LOCATION } from 'components/SelfServices/Steps/common';
import { SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';

import type Flow from 'types/Flow';

import { REOPEN_VERIFY } from '../common';

export type ShareboxS32ReopenSteps = SelfServiceSteps.REOPEN_VERIFY | SelfServiceSteps.KIOSK_LOCATION;

// Alias 'OUTDOOR' flow
const SHAREBOX_S32_REOPEN_STEPS: Flow<ShareboxS32ReopenSteps> = {
  REOPEN_VERIFY: {
    ...REOPEN_VERIFY,
    next: KIOSK_LOCATION.key,
  },
  KIOSK_LOCATION: {
    ...KIOSK_LOCATION,
    previous: REOPEN_VERIFY.key,
    data: {
      ...KIOSK_LOCATION.data,
      isVisible: true,
    },
  },
};

export default SHAREBOX_S32_REOPEN_STEPS;
